import { all, create } from "mathjs";

import { extendMath } from "./extendMath";

const math = create(all);
extendMath(math);
export default math;
